import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./locationFilter.html";
import { selectFilterLocation, WireI18n } from '~/modules/stores/i18nStore';
class LocationFilter extends LightningElement {
  constructor(...args) {
    super(...args);
    this.options = void 0;
    this.value = void 0;
    this.section = void 0;
    this.labels = void 0;
  }
  get stateDisabled() {
    if (this.selectedOption?.states) {
      return this.selectedOption.states.length === 0;
    }
    return true;
  }
  get countryOptions() {
    const {
      country
    } = this.parseSelectedValue();
    const isDefault = !country;
    return this.options.map((option, index) => {
      const selected = isDefault ? !!option.default : option.value === country;
      if (selected) {
        this.selectedOption = option;
      }
      const value = option.states?.length > 0 ? `${option.value}-*` : option.value;
      return {
        label: option.label,
        value: value,
        key: `key-${index}`,
        selected: selected,
        disabled: !!option.disabled
      };
    });
  }
  get stateOptions() {
    const {
      state
    } = this.parseSelectedValue();
    if (this.selectedOption?.states?.length > 0) {
      // @ts-expect-error * Automated Type Error Fix
      return this.selectedOption.states.map((option, index) => {
        const selected = option.value === state;
        return {
          ...option,
          key: `key-${index}`,
          selected: selected
        };
      });
    }
    return [{
      label: this.labels.choose,
      key: 'key-0'
    }];
  }
  countryChangeHandler(event) {
    const target = event.target;
    this.dispatchEvent(new CustomEvent('filterchange', {
      detail: {
        section: this.section,
        value: [target.value]
      },
      composed: true,
      bubbles: true,
      cancelable: true
    }));
  }
  stateChangeHandler(event) {
    const target = event.target;
    this.dispatchEvent(new CustomEvent('filterchange', {
      detail: {
        section: this.section,
        value: [`${this.selectedOption.value}-${target.value}`]
      },
      composed: true,
      bubbles: true,
      cancelable: true
    }));
  }
  parseSelectedValue() {
    if (this.value) {
      const [country, state] = this.value.split('-');
      return {
        country,
        state
      };
    }
    return {};
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(LocationFilter, {
  publicProps: {
    options: {
      config: 0
    },
    value: {
      config: 0
    },
    section: {
      config: 0
    }
  },
  wire: {
    labels: {
      adapter: WireI18n,
      dynamic: [],
      config: function ($cmp) {
        return {
          selector: selectFilterLocation
        };
      }
    }
  }
});
const __lwc_component_class_internal = _registerComponent(LocationFilter, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;